/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function PlugIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "plug", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M9 12L7 14L10 17L12 15C14 16.5 15 16 16 15L17.5 13.5L10.5 6.5L9 8C8 9 7.5 10 9 12Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 8.5L16 5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M15.5 11.5L19 8", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M8.5 15.5L4.5 19.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(PlugIcon);
export default ForwardRef;
//# sourceMappingURL=plugIcon.js.map